import React from "react";
import DashboardHeader from "./DashboardHeader";
import LicenseCard from "./LicenseCard";
import InstallationCard from "./InstallationCard";
import LiveTradingCard from "./LiveTradingCard";
import ExpertAdvisorCard from "./ExpertAdvisorCard";
import TradingIntelligenceCard from "./TradingIntelligenceCard";
import InstallationDetailsModal from "./InstallationDetailsModal";
import ConfirmDeactivateModal from "./ConfirmDeactivateModal";
import ITWSLiveTradingCard from "./ITWSLiveTradingCard";


import {

    getInstallations,
    getLicense,
    getActivation,
    deactivateInstallation,
    downloadEA
}
from "./dashboardService";


import "./theme.css";

import "./Dashboard.css";



class Dashboard extends React.Component {


constructor(props){

super(props);

this.state={

    loading:true,

    error:null,

    userName:"Trader",

    subscription:"Professional",

    aiStatus:"Online",

    //installations:[],

    license:null,

    activation:null,

    selectedInstallation:null,

    showDetailsModal:false,

    showDeactivateModal:false,

    activationCode        :"" ,

    eaVersion             :"" ,

    maxInstallations      :  3,

    activeInstallations   : 0 ,

    availableSlots        : 3 ,

};



}


// =====================================================
// Load downloadEA Data
// =====================================================

handleDownloadEA  = async () => {

    try {

        this.setState({

            downloading: true
        });

        const result = await downloadEA();

        window.location.href = result.downloadUrl;

        this.setState({activationCode : result.activationCode}) ;
        
        this.setState({eaVersion      : result.eaVersion}) ;

        this.setState({maxInstallations      : 3}) ;

        this.setState({activeInstallations   : 1}) ;

        this.setState({availableSlots        : 2}) ; 

        console.log('result  download : ' + JSON.stringify(result));

    }
    catch (error) {

        console.error(error);
        alert("Unable to download the Expert Advisor.");
    }
    finally {

        this.setState({
            downloading: false
        });
    }
};

// =====================================================
// Load openInstallationDetails Data
// =====================================================

openInstallationDetails = (installation) => {


    this.setState({

        selectedInstallation: installation,
        showInstallationDetails: true
    });


};


// =====================================================
// Load closeInstallationDetails Data
// =====================================================

closeInstallationDetails = () => {

    this.setState({

        selectedInstallation:null,
        showInstallationDetails:false
    });


};


// =====================================================
// Load openDeactivate Data
// =====================================================

openDeactivate = (installation)=>{

    this.setState({

        selectedInstallation:installation,
        showDeactivateModal:true
    });

};


// =====================================================
// Load closeDeactivate Data
// =====================================================

closeDeactivate = ()=>{

   this.setState(

    {

        selectedInstallation: null,
        showDeactivateModal: false
    },

     () => {

        this.loadDashboard();
    }


  );

};


// =====================================================
// Load confirmDeactivate Data
// =====================================================

confirmDeactivate = async (installation)=>{

    await deactivateInstallation({

        installationId: installation.installationId
    });


     this.closeDeactivate();

    //await  this.loadDashboard();


};








// =====================================================
// Load Dashboard Data
// =====================================================


componentDidMount(){

    this.loadDashboard();


    /*socket.emit("installation_updated", {
    userId,
    installationId
    });*/

    /*socket.on(
    "installation_updated",
    () => {

        this.loadDashboard();
    }
    );*/

    
}




/*________________________________ */

loadDashboard = async () => {

    try {


        const installations =
            await getInstallations();

        this.setState({

            installations: installations,

            loading : false

        });

    }
    catch(error){

        console.error(
            "INSTALLATIONS ERROR:",
            error
        );

    }

}



/*loadDashboard = async ()=>{


try{

    this.setState({

        loading:true

    });



    const [

        installations,

        license,

        activation


    ] = await Promise.all([



        this.getInstallations(),



        //this.getLicense(),



        //this.getActivation()



    ]);





    console.log(
    "BEFORE SETSTATE:",
    installations
);


    this.setState({



        installations,

        license,

        activation,

        loading:false



    });


    this.setState(
{
    installations: installations
},
()=>{

    console.log(
        "STATE installations:",
        this.state.installations
    );

});





}

catch(error){



    console.error(error);



    this.setState({


        error:

        "Unable to load dashboard data",


        loading:false


    });



}



}*/








/*________________________________ */

openDetails=(installation)=>{

    this.setState({

        selectedInstallation:installation,

        showDetailsModal:true

    });

}

/*________________________________ */

closeDetails=()=>{

    this.setState({

        selectedInstallation:null,

        showDetailsModal:false
    });


}



/*________________________________ */

openDeactivate=(installation)=>{

    this.setState({

        selectedInstallation:installation,

        showDeactivateModal:true
    });


}


/*________________________________ */

closeDeactivate=()=>{

    this.setState({

        selectedInstallation:null,

        showDeactivateModal:false
    });

    //this.loadDashboard();


}



/*________________________________ */

closeDetails = () => {

    this.setState({

        selectedInstallation:null,

        showDetailsModal:false
    });

};




/*________________________________ */

confirmDeactivate=async()=>{


    const installation =  this.state.selectedInstallation;

    await deactivateInstallation( installation.installationId );

    this.setState({

        showDeactivateModal:false
    });


    // reload fresh data

    this.loadDashboard();

}









render(){


    {/*________________________________ */}
    if(this.state.loading) {

        return(

        <div className="dashboard-loading">

            <h2>
                iDMS
            </h2>

            <p>
                    Loading your trading environment...
            </p>

        </div>

        );

    }

    {/*________________________________ */}
    if(this.state.error) {

        return(

        <div className="dashboard-error">

             {this.state.error}

        </div>

        );

    }



return(


    <div className="dashboard-root">


        <div className="dashboard-container">

            {/*________________________________ */}
                    <DashboardHeader

                        userName={this.state.userName}

                        subscription={this.state.subscription}

                        aiStatus={this.state.aiStatus}

                    />



            <div className="dashboard-grid">


                {/*________________________________ */}
                <LiveTradingCard />



                {/*________________________________ */}
                <LicenseCard

                    installations={this.state.installations}

                />

                {/*________________________________ */}
                <InstallationCard

                    installations={this.state.installations}

                    onDetails={this.openDetails}

                    onDeactivate={this.openDeactivate}

                    onRefresh={() => this.loadDashboard()}

                    showDetailsModal={this.showDetailsModal}

                    selectedInstallation={this.selectedInstallation}

                />

                {/*________________________________ 
                <LiveTradingCard />*/}


                {/*________________________________ */}
                <ExpertAdvisorCard

                        //activationCode={
                            //this.state.activation &&
                            //this.state.activation.activationCode
                        //}

                        
                         activationCode={
                            this.state.activationCode
                         }

                         onDownloadEA = { this.handleDownloadEA }
                />


                 <ITWSLiveTradingCard />

                {/*________________________________ */}
                <TradingIntelligenceCard

                    installations={this.state.installations}

                    onDetails={this.openDetails}

                    onDeactivate={this.openDeactivate}

                />


               
                

        </div>


    </div>

     {/*________________________________ */}

    {this.state.showDetailsModal &&


        <InstallationDetailsModal

            installation={this.state.selectedInstallation}

            onClose={this.closeDetails}

            showDetailsModal = {this.state.showDetailsModal}
        />

    }

    {/*________________________________ */}

    {this.state.showDeactivateModal &&

        <ConfirmDeactivateModal

            installation={ this.state.selectedInstallation}

            onCancel={this.closeDeactivate}

            onConfirm={this.confirmDeactivate}

        />

    }


   </div>


   );

  }

}


export default Dashboard;